<template>
  <div class="gifContainer">
    <lottie-player
      class="lottie-player"
      autoplay
      loop
      mode="normal"
      :src="myJson"
    ></lottie-player>
  </div>
</template>



<script>
import json from "../assets/loader-blue.json";

export default {
  data() {
    return {
      myJson: JSON.stringify(json),
    };
  },
};
</script>



<style scoped>
.gifContainer {
  width: 100%;
  height: 100vh;
  text-align: center;
}

.lottie-player {
  vertical-align: center;
  width: 8rem;
  margin: auto;
}

@media only screen and (max-width: 500px) {
  .lottie-player {
    width: 6rem;
  }
}
</style>
